import { BrandLoader } from '@/components/common/BrandLoader'
import { cn } from '@/lib/utils'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  /** Показываемый процент (`useSmoothProgress`). */
  percent: number
  /** Цвета: у холста — из `blockTheme`, у панели — токены приложения. */
  colors: { title: string; track: string; fill: string }
  /** `sm` — для маленьких мест (слот маскота 110px): лоадер и подпись мельче. */
  size?: 'md' | 'sm'
}

/** Идёт загрузка картинки: фирменный лоадер, «Загружаю… N%» и полоса прогресса снизу. */
export const UploadProgressBody = ({ percent, colors, size = 'md' }: Props) => {
  const m = useMessages(messages)
  return (
    <div
      className={cn(
        'flex w-full max-w-[220px] flex-col items-center',
        size === 'sm' ? 'gap-1.5' : 'gap-3',
      )}
      aria-busy
    >
      <BrandLoader className={size === 'sm' ? 'size-6' : 'size-8'} />
      <span className="text-sm font-semibold tabular-nums" style={{ color: colors.title }}>
        {/* В маленьком месте — только процент: «Загружаю… N%» ломалось на две строки. */}
        {size === 'sm' ? `${Math.round(percent)}%` : m.uploadingPercent(Math.round(percent))}
      </span>
      <div
        className="h-1.5 w-full overflow-hidden rounded-full"
        style={{ backgroundColor: colors.track }}
      >
        <div
          className="h-full rounded-full transition-[width] duration-150 ease-linear"
          style={{ width: `${percent}%`, backgroundColor: colors.fill }}
        />
      </div>
    </div>
  )
}
